import React from 'react'
import {Switch, Route, Navigate } from 'react-router-dom'
import LoadableComponent from 'utils/LoadableComponent'

const Home = LoadableComponent(()=>import('routes/Home/index'))  //参数一定要是函数，否则不会懒加载，只会代码拆分

const AccountBalance = LoadableComponent(()=>import('routes/Trade/accountBalance'))

const AccountOrder = LoadableComponent(()=>import('routes/Trade/order'))

const TransferInner = LoadableComponent(()=>import('routes/Trade/transferInner'))

const TransferSub = LoadableComponent(()=>import('routes/Trade/transferSub'))

const StrategyPosition = LoadableComponent(()=>import('routes/Trade/strategyPosition'))

const ProfitAnalyse = LoadableComponent(()=>import('routes/Analyse/profit'))

const StrategySymbolPnl = LoadableComponent(()=>import('routes/Analyse/strategySymbolPnl'))

const SlippageAnalyse = LoadableComponent(()=>import('routes/Analyse/slippage'))

const SymbolVolumeAnalyse = LoadableComponent(()=>import('routes/Analyse/symbolVolumeAnalyse'))

const TurnoverRate = LoadableComponent(()=>import('routes/Analyse/turnoverRate'))

const FeeAnalyse = LoadableComponent(()=>import('routes/Analyse/fee'))

const Kline = LoadableComponent(()=>import('routes/DataMgr/Kline/index'))

const Funding = LoadableComponent(()=>import('routes/DataMgr/Funding/index'))

const Indicator = LoadableComponent(()=>import('routes/DataMgr/Indicator/index'))

const StrategyList = LoadableComponent(()=>import('routes/Strategy/strategyList'))

const BackSelectCoin = LoadableComponent(()=>import('routes/Strategy/backSelectCoin'))

const BacktestResult = LoadableComponent(()=>import('routes/Strategy/backResult'))

const TraversalResult = LoadableComponent(()=>import('routes/Strategy/traversalResult'))

const BackTradeCompare = LoadableComponent(()=>import('routes/Strategy/backTradeCompare'))

const StrategyHeatmap = LoadableComponent(()=>import('routes/Strategy/strategyHeatmap'))

const PanelAnalyse = LoadableComponent(()=>import('routes/Factor/panelAnalyse'))

const FactorVisual = LoadableComponent(()=>import('routes/Factor/factorVisual'))

class ContentMain extends React.Component {
  render () {
    return (
      <div style={{padding: 16, position: 'relative'}}>
        <Switch>
          <Route exact path='/admin' component={Home}/>

          <Route exact path='/admin/trade/balance' component={AccountBalance}/>

          <Route exact path='/admin/trade/position' component={StrategyPosition}/>

          <Route exact path='/admin/trade/order' component={AccountOrder}/>

          <Route exact path='/admin/trade/transfer-inner' component={TransferInner}/>

          <Route exact path='/admin/trade/transfer-sub' component={TransferSub}/>

          <Route exact path='/admin/analyse/profit' component={ProfitAnalyse}/>

          <Route exact path='/admin/analyse/strategy-symbol-pnl' component={StrategySymbolPnl}/>

          <Route exact path='/admin/analyse/slippage' component={SlippageAnalyse}/>
          
          <Route exact path='/admin/analyse/symbol-volume' component={SymbolVolumeAnalyse}/>

          <Route exact path='/admin/analyse/turnover' component={TurnoverRate}/>

          <Route exact path='/admin/analyse/fee' component={FeeAnalyse}/>

          <Route exact path='/admin/data/kline' component={Kline}/>

          <Route exact path='/admin/data/funding' component={Funding}/>

          <Route exact path='/admin/data/indicator' component={Indicator}/>

          <Route exact path='/admin/strategy/list' component={StrategyList}/>

          <Route exact path='/admin/strategy/select-coin' component={BackSelectCoin}/>

          <Route exact path='/admin/strategy/back-result' component={BacktestResult}/>

          <Route exact path='/admin/strategy/traversal-result' component={TraversalResult}/>

          <Route exact path='/admin/strategy/back-trade-cmp' component={BackTradeCompare}/>

          <Route exact path='/admin/strategy/heatmap' component={StrategyHeatmap}/>

          <Route exact path='/admin/factor/panel' component={PanelAnalyse}/>

          <Route exact path='/admin/factor/visual' component={FactorVisual}/>

        </Switch>
      </div>
    )
  }
}

export default ContentMain



// WEBPACK FOOTER //
// ./src/components/ContentMain/index.js